module.exports = __webpack_public_path__ + "img/step4.9ca42d45.png";